// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"on-z","imageAndVideoCount":"pn-z","imageAndVideoContainer":"qn-z","viewAllReviews":"rn-z"};